(function (win) {
    'use strict';

    const fp = (win.fp = win.fp || {});
    const home = (fp.home = fp.home || {});
    let initialized = false;

    // =========================================
    // Get Screen Size
    // =========================================
    const getScreenSize = () => {
        const pixelDensity = window.devicePixelRatio || 1;
        const width = window.innerWidth * pixelDensity;

        if (width >= 2400) return 'xlarge';
        if (width >= 1400) return 'large';
        if (width >= 1000) return 'medium';
        if (width >= 600) return 'small';
        return 'xsmall';
    };

    // =========================================
    // Set Background Image
    // =========================================
    const setBgImage = (imgInfo = []) => {
        if (!imgInfo.length) {
            //console.warn('No images provided for background.');
            return;
        }

        const slideshowEl = document.querySelector('.slideshow.background-photos');

        if (!slideshowEl) {
            //console.warn('.slideshow element not found in DOM.');
            return;
        }

        const screenSize = getScreenSize();
        const filteredImages = imgInfo.filter((img) => img.assetSize === screenSize);
        if (!filteredImages.length) {
            //console.warn('No matching images for screen size:', screenSize);
            return;
        }

        const randomImage = filteredImages[Math.floor(Math.random() * filteredImages.length)];

        slideshowEl.style.backgroundImage = `url('${randomImage.imagePath}')`;
        if (randomImage.altText) {
            slideshowEl.setAttribute('aria-label', randomImage.altText);
            slideshowEl.setAttribute('role', 'img');
        }
    };

    // =========================================
    // Detect Scroll
    // =========================================
    const detectScroll = () => {
        const height = window.scrollY || window.pageYOffset;
        document.body.classList.toggle('scrolled-down', height > 50);
    };
    window.addEventListener('scroll', detectScroll);

    // =========================================
    // Size Detector
    // =========================================
    const sizeDetector = () => {
        const root = document.documentElement;

        const setCSSVariable = (varName, value) => {
            root.style.setProperty(varName, `${value}px`);
            //console.log(varName + ": " + value);
        };

        const header = document.querySelector('header');
        setCSSVariable(
            '--header-height', header ? header.offsetHeight : 0
        );

        const logoMobile = document.querySelector('#logo-mobile');
        setCSSVariable(
            '--logo-mobile-height', logoMobile ? logoMobile.offsetHeight : 0
        );

        const utility = document.querySelector('#utility');
        setCSSVariable(
            '--utility-height', utility ? utility.offsetHeight : 0
        );

        const specialMessage = document.querySelector('#special-message.message-banner');
        setCSSVariable(
            '--special-message-height',
            specialMessage && getComputedStyle(specialMessage).display !== 'none' ? specialMessage.offsetHeight : 0
        );

        const stickyFooter = document.querySelector('#ao-sticky');
        setCSSVariable(
            '--sticky-footer-height',
            stickyFooter && getComputedStyle(stickyFooter).display !== 'none' ? stickyFooter.offsetHeight : 0
        );
    };

    // =========================================
    // Set Hero Size
    // =========================================
    const setHeroSize = () => {
        if (!document.body.classList.contains('hero-set')) {
            setTimeout(() => {
                document.body.classList.add('hero-set');
            }, 1000);
        }
    };

    // =========================================
    // Setup Video Controls
    // =========================================
    const setupVideoControls = () => {
        const video = document.getElementById('bg-video');
        const videoButton = document.getElementById('video-pause-play');
        const videoButtonIcon = videoButton ? videoButton.querySelector('span') : null;
        const controlAnnouncements = document.getElementById('video-control-announcements');

        if (!video || !videoButton || !videoButtonIcon || !controlAnnouncements) {
            //console.warn("Video controls not fully initialized: missing elements");
            return;
        }

        videoButton.addEventListener('click', () => {
            if (!video.paused) {
                video.pause();
                videoButton.setAttribute('aria-label', 'Play video');
                videoButtonIcon.classList.replace('icon-pause', 'icon-play');
                controlAnnouncements.textContent = 'Video paused';
            } else {
                video.play();
                videoButton.setAttribute('aria-label', 'Pause video');
                videoButtonIcon.classList.replace('icon-play', 'icon-pause');
                controlAnnouncements.textContent = 'Video playing';
            }
        });
    };

    // =========================================
    // Debounce Utility
    // =========================================
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // =========================================
    // Window Resize Handler
    // =========================================
    const handleResize = () => {
        setHeroSize();
        sizeDetector();
    };

    const debouncedResizeHandler = debounce(handleResize, 250);
    window.addEventListener('resize', debouncedResizeHandler);

    // =========================================
    // Initialize Functions on Load
    // =========================================
    window.addEventListener('load', () => {
        setTimeout(sizeDetector, 250);
    });

    // =========================================
    // Public API
    // =========================================
    fp.home.init = (imgInfo = []) => {
        if (initialized) return;
        initialized = true;

        const homepageLink = document.querySelector('.homepage-link');
        if (homepageLink) homepageLink.classList.add('selected');

        setBgImage(imgInfo); // Pass the image data here
        setupVideoControls();
        setHeroSize();
    };
})(window);